import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Menu, Icon, Button, Row, Col, Input, Dropdown, Tooltip } from 'antd'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { AutorizeMenu } from '../../shared/components/CustomMenu'
import { checkPermissions } from '../../../lib/helper'
import CustomMenuItem from '../../shared/components/CustomMenuItem'

import { autoGenKey } from '../../../lib/helper'

// svg icon
import {
  ShieldCheckIcon,
  TruckIcon,
  FileTextIcon,
  SettingIcon,
  MenuIcon,
} from 'modules/ui/components/Icon.js'

// ฟังก์ชัน Debounce - หน่วงเวลาการทำงานเพื่อลดการเรียกซ้ำ
const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

class SliderBarNewNode extends Component {
  // ตรวจสอบว่าเป็น root submenu หรือไม่ (ใช้ pattern -sub-menu)
  isRootSubmenu = (key) => {
    return key && key.endsWith('-sub-menu')
  }

  state = {
    openKeys: [],
    isActive: '',
    web_endpoint: '',
    searchText: '',
    searchResults: [],
    showDropdown: false,
    searchHistory: [], // ประวัติการค้นหาล่าสุด
  }

  componentDidMount() {
    this.setState({
      web_endpoint: process.env.REACT_APP_WEB_ENDPOINT,
    })
    // โหลดประวัติการค้นหาจาก localStorage
    this.loadSearchHistory()
  }

  componentDidUpdate(prevProps) {
    // ถ้า drawer เปลี่ยนจากเปิดเป็นปิด ให้ปิด dropdown ด้วย
    if (prevProps.drawerVisible && !this.props.drawerVisible) {
      this.closeDropdown()
    }
  }

  // โหลดประวัติการค้นหาจาก localStorage (แยกตาม user id)
  // โครงสร้าง: autocomplete.menu_search_history[userId]
  loadSearchHistory = () => {
    try {
      var userId =
        this.props.profile && this.props.profile.id
          ? this.props.profile.id
          : 'guest'
      var autocompleteData = localStorage.getItem('autocomplete')
      if (autocompleteData) {
        var parsed = JSON.parse(autocompleteData)
        // ใช้โครงสร้าง autocomplete.menu_search_history[userId]
        if (
          parsed &&
          parsed.menu_search_history &&
          parsed.menu_search_history[userId] &&
          Array.isArray(parsed.menu_search_history[userId])
        ) {
          this.setState({ searchHistory: parsed.menu_search_history[userId] })
        }
      }
    } catch (e) {
      console.error('ไม่สามารถโหลดประวัติการค้นหาได้:', e)
    }
  }

  // บันทึกประวัติการค้นหาลง localStorage (แยกตาม user id)
  // โครงสร้าง: autocomplete.menu_search_history[userId]
  saveSearchHistory = (item) => {
    try {
      var userId =
        this.props.profile && this.props.profile.id
          ? this.props.profile.id
          : 'guest'
      var currentHistory = this.state.searchHistory.slice()

      // ลบรายการซ้ำ (ถ้ามี)
      var filteredHistory = currentHistory.filter(function(h) {
        return h.key !== item.key
      })

      // เพิ่มรายการใหม่ที่ต้นลิสต์
      var newHistory = [
        {
          name: item.name,
          path: item.path,
          key: item.key,
          urlType: item.urlType,
          timestamp: new Date().getTime(),
        },
      ].concat(filteredHistory)

      // จำกัดไว้ 5 รายการ
      if (newHistory.length > 5) {
        newHistory = newHistory.slice(0, 5)
      }

      // อ่าน autocomplete เดิมจาก localStorage (เพื่อไม่ให้เขียนทับข้อมูลอื่น)
      var autocompleteData = localStorage.getItem('autocomplete')
      var autocomplete = {}
      if (autocompleteData) {
        try {
          autocomplete = JSON.parse(autocompleteData) || {}
        } catch (e) {
          autocomplete = {}
        }
      }

      // สร้าง menu_search_history ถ้ายังไม่มี
      if (!autocomplete.menu_search_history) {
        autocomplete.menu_search_history = {}
      }

      // เพิ่ม/อัพเดท menu_search_history[userId]
      autocomplete.menu_search_history[userId] = newHistory

      // บันทึกกลับลง localStorage
      localStorage.setItem('autocomplete', JSON.stringify(autocomplete))

      // อัพเดท state
      this.setState({ searchHistory: newHistory })
    } catch (e) {
      console.error('ไม่สามารถบันทึกประวัติการค้นหาได้:', e)
    }
  }

  // ลบรายการประวัติการค้นหา
  // โครงสร้าง: autocomplete.menu_search_history[userId]
  removeSearchHistoryItem = (itemKey, e) => {
    // หยุดการ propagate event เพื่อไม่ให้เปิดลิงก์
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    try {
      var userId =
        this.props.profile && this.props.profile.id
          ? this.props.profile.id
          : 'guest'
      var currentHistory = this.state.searchHistory.slice()

      // กรองรายการที่ต้องการลบออก
      var newHistory = currentHistory.filter(function(h) {
        return h.key !== itemKey
      })

      // อ่าน autocomplete เดิมจาก localStorage
      var autocompleteData = localStorage.getItem('autocomplete')
      var autocomplete = {}
      if (autocompleteData) {
        try {
          autocomplete = JSON.parse(autocompleteData) || {}
        } catch (err) {
          autocomplete = {}
        }
      }

      // สร้าง menu_search_history ถ้ายังไม่มี
      if (!autocomplete.menu_search_history) {
        autocomplete.menu_search_history = {}
      }

      // อัพเดท menu_search_history[userId]
      autocomplete.menu_search_history[userId] = newHistory

      // บันทึกกลับลง localStorage
      localStorage.setItem('autocomplete', JSON.stringify(autocomplete))

      // อัพเดท state
      this.setState({ searchHistory: newHistory })
    } catch (err) {
      console.error('ไม่สามารถลบรายการประวัติการค้นหาได้:', err)
    }
  }

  // สร้างรายการเมนูจาก permissions array แบบ dynamic ตามสิทธิ์ของผู้ใช้
  // ดึงชื่อเมนูจาก i18n ตาม matching_name
  getI18nMenuName = (matchingName, language) => {
    // section มาจากตัวอักษรตัวแรกของ matching_name (lowercase)
    var section = matchingName.charAt(0).toLowerCase()
    var langDict = i18n[language] || i18n.th

    if (langDict && langDict[section] && langDict[section][matchingName]) {
      return langDict[section][matchingName]
    }
    return null
  }

  buildMenuItemsFromPermissions = (permissions, language) => {
    var self = this
    if (!permissions || !Array.isArray(permissions)) {
      return []
    }

    // กรองหลัก
    var viewablePermissions = permissions.filter(function(p) {
      return (
        p.can_view === 1 &&
        p.name &&
        p.url &&
        (p.web_use === 'isupply' || p.web_use === null || p.web_use === '')
      )
    })

    // แปลงเป็นรายการเมนูพร้อมชื่อตามภาษา
    var menuItems = viewablePermissions.map(function(p) {
      var displayName = ''
      if (language === 'en' && p.name_en) {
        displayName = p.name_en
      } else {
        displayName = p.name
      }

      let menuHirarchyArr = []
      let menuHierarchyTrans = ''
      if (p.menu_hierarchy) {
        menuHirarchyArr = p.menu_hierarchy.split(' ')
        menuHirarchyArr = menuHirarchyArr.filter(
          (item) => item !== '>' && item !== '<',
        )
        menuHierarchyTrans = menuHirarchyArr
          .map((item) => i18n[language].menuHierarchy[item] || item)
          .join(' > ')
      }

      return {
        name: displayName,
        path: p.url,
        menu_hierarchy: p.menu_hierarchy,
        menu_hierarchy_trans: menuHierarchyTrans,
        key: p.matching_name,
        urlType: p.url_type || 1,
      }
    })

    return menuItems
  }

  // คำนวณคะแนนความคล้ายคลึง - คะแนนสูง = คล้ายมากกว่า (ระบบคะแนนละเอียด)
  calculateSimilarity = (itemName, searchText) => {
    var nameLower = itemName.toLowerCase()
    var searchLower = searchText.toLowerCase()
    var score = 0

    // 1. ตรงกันทั้งหมด - ความสำคัญสูงสุด
    if (nameLower === searchLower) {
      return 10000
    }

    // 2. ตรวจสอบว่าคำค้นหาอยู่ในชื่อเมนูหรือไม่
    var index = nameLower.indexOf(searchLower)
    if (index === -1) {
      // ลองจับคู่ทีละคำสำหรับการค้นหาบางส่วน
      var searchWords = searchLower.split(/\s+/)
      var matchedWords = 0
      var totalWordScore = 0

      for (var i = 0; i < searchWords.length; i++) {
        var word = searchWords[i]
        if (word.length > 0 && nameLower.indexOf(word) !== -1) {
          matchedWords++
          // โบนัสถ้าคำอยู่ที่ต้น
          if (nameLower.indexOf(word) === 0) {
            totalWordScore += 200
          } else {
            totalWordScore += 100
          }
        }
      }

      if (matchedWords === 0) return -1

      // คะแนนการจับคู่บางส่วน
      score = totalWordScore + (matchedWords / searchWords.length) * 500
      return score
    }

    // 3. คะแนนพื้นฐานสำหรับการจับคู่ substring
    score = 1000

    // 4. โบนัสตำแหน่ง - พบก่อน = คะแนนสูงกว่า
    // พบที่ตำแหน่ง 0 ได้ +800 ลดลงตามตำแหน่งที่ห่างออกไป
    var positionBonus = Math.max(0, 800 - index * 50)
    score += positionBonus

    // 5. โบนัสขอบเขตคำ - ถ้าพบที่จุดเริ่มต้นของคำ
    if (index === 0 || nameLower.charAt(index - 1) === ' ') {
      score += 600
    }

    // 6. โบนัสอัตราส่วนความยาว - สัดส่วนที่จับคู่ได้
    var lengthRatio = searchText.length / itemName.length
    score += lengthRatio * 400

    // 7. โบนัสการจับคู่ติดต่อกัน - ติดกันยาว = ดีกว่า
    var consecutiveLength = 0
    var maxConsecutive = 0
    var nameIndex = 0
    for (var j = 0; j < searchLower.length; j++) {
      var foundAt = nameLower.indexOf(searchLower.charAt(j), nameIndex)
      if (foundAt !== -1 && foundAt === nameIndex) {
        consecutiveLength++
        nameIndex = foundAt + 1
      } else if (foundAt !== -1) {
        maxConsecutive = Math.max(maxConsecutive, consecutiveLength)
        consecutiveLength = 1
        nameIndex = foundAt + 1
      } else {
        maxConsecutive = Math.max(maxConsecutive, consecutiveLength)
        consecutiveLength = 0
      }
    }
    maxConsecutive = Math.max(maxConsecutive, consecutiveLength)
    score += maxConsecutive * 30

    // 8. โบนัสชื่อสั้น - ผลลัพธ์ที่เจาะจงกว่า
    var lengthPenalty = Math.min(itemName.length * 2, 100)
    score += 100 - lengthPenalty

    // 9. โบนัสตรง case - ถ้าตัวพิมพ์ใหญ่เล็กตรงกัน
    var originalIndex = itemName.indexOf(searchText)
    if (originalIndex !== -1) {
      score += 150
    }

    // 10. โบนัสตรงทั้งคำ - ถ้าคำค้นหาตรงกับคำเต็มในชื่อ
    var words = nameLower.split(/\s+/)
    for (var k = 0; k < words.length; k++) {
      if (words[k] === searchLower) {
        score += 700
        break
      }
      if (words[k].indexOf(searchLower) === 0) {
        score += 300
      }
    }

    return score
  }

  // การค้นหาขั้นสูง - รองรับหลายโหมดการค้นหา
  matchesSearch = (itemName, searchText) => {
    var nameLower = itemName.toLowerCase()
    var searchLower = searchText.toLowerCase().trim()

    // 1. ค้นหาตรงๆ แบบ substring
    if (nameLower.indexOf(searchLower) !== -1) {
      return true
    }

    // 2. ค้นหาทีละคำ (ต้องพบทุกคำ)
    var searchWords = searchLower.split(/\s+/).filter(function(w) {
      return w.length > 0
    })
    if (searchWords.length > 1) {
      var allWordsFound = true
      for (var i = 0; i < searchWords.length; i++) {
        if (nameLower.indexOf(searchWords[i]) === -1) {
          allWordsFound = false
          break
        }
      }
      if (allWordsFound) return true
    }

    // 3. ค้นหาตัวอักษรย่อ (เช่น "กจค" ค้นหา "การจัดส่งคอนกรีต")
    if (searchLower.length >= 2) {
      var nameWords = nameLower.split(/\s+/)
      var initials = ''
      for (var j = 0; j < nameWords.length; j++) {
        if (nameWords[j].length > 0) {
          initials += nameWords[j].charAt(0)
        }
      }
      if (initials.indexOf(searchLower) !== -1) {
        return true
      }
    }

    // 4. ค้นหาแบบ fuzzy - อนุญาตให้พิมพ์ผิด 1 ตัวอักษร สำหรับคำค้นหาที่ยาว
    if (searchLower.length >= 4) {
      for (var k = 0; k < searchLower.length; k++) {
        var fuzzySearch =
          searchLower.substring(0, k) + searchLower.substring(k + 1)
        if (nameLower.indexOf(fuzzySearch) !== -1) {
          return true
        }
      }
    }

    return false
  }

  // ตัวจัดการค้นหาแบบ debounce - หน่วงเวลา 300ms
  debouncedSearch = debounce((searchText, permissions, language) => {
    var self = this
    if (!searchText.trim()) {
      this.setState({ searchResults: [], showDropdown: false })
      return
    }

    var menuItems = this.buildMenuItemsFromPermissions(permissions, language)

    // กรองด้วยการค้นหาขั้นสูงและเพิ่มคะแนนความคล้ายคลึง
    var resultsWithScore = menuItems
      .filter(function(item) {
        return item.name && self.matchesSearch(item.name, searchText)
      })
      .map(function(item) {
        return {
          ...item,
          name: item.name,
          path: item.path,
          key: item.key,
          urlType: item.urlType,
          score: self.calculateSimilarity(item.name, searchText),
        }
      })

    // เรียงตามคะแนนความคล้ายคลึง (สูงสุดก่อน)
    resultsWithScore.sort(function(a, b) {
      return b.score - a.score
    })

    // จำกัดผลลัพธ์ 10 รายการ
    var results = resultsWithScore.slice(0, 10)

    this.setState({
      searchResults: results,
      showDropdown: results.length > 0,
    })
  }, 300)

  // จัดการการเปลี่ยนแปลงค่าในช่องค้นหา
  handleSearchChange = (e, permissions, language) => {
    var searchText = e.target.value
    this.setState({ searchText: searchText })

    // ถ้า input ว่าง ให้แสดง dropdown (ประวัติค้นหา)
    if (!searchText.trim()) {
      this.setState({ showDropdown: true, searchResults: [] })
    } else {
      this.debouncedSearch(searchText, permissions, language)
    }
  }

  // จัดการการแสดง/ซ่อน dropdown
  handleDropdownVisibleChange = (visible) => {
    // ใช้ setTimeout เพื่อให้ click event ทำงานก่อน
    var self = this
    if (!visible) {
      setTimeout(function() {
        // ตรวจสอบว่า input ยัง focus อยู่หรือไม่
        if (!self.isInputFocused) {
          self.setState({ showDropdown: false })
        }
      }, 200)
    }
  }

  // ปิด dropdown จากภายนอก (เช่น เมื่อ drawer ปิด)
  closeDropdown = () => {
    this.isInputFocused = false
    this.setState({ showDropdown: false })
  }

  // จัดการเมื่อคลิกเลือกเมนูจากผลค้นหา
  handleSearchItemClick = (item) => {
    // บันทึกประวัติการค้นหา
    this.saveSearchHistory(item)

    this.isInputFocused = false
    this.setState({
      searchText: '',
      searchResults: [],
      showDropdown: false,
      isActive: item.key,
    })
  }

  // ไฮไลท์ข้อความที่ตรงกับคำค้นหาในผลลัพธ์
  highlightText = (text, searchText) => {
    if (!searchText.trim()) return text

    var searchLower = searchText.toLowerCase()
    var textLower = text.toLowerCase()
    var index = textLower.indexOf(searchLower)

    if (index === -1) return text

    var before = text.substring(0, index)
    var match = text.substring(index, index + searchText.length)
    var after = text.substring(index + searchText.length)

    return (
      <span>
        {before}
        <span style={{ color: '#ff0000', fontWeight: 'bold' }}>{match}</span>
        {after}
      </span>
    )
  }

  // จัดการเมื่อ focus ที่ช่องค้นหา - แสดงประวัติ
  handleSearchFocus = () => {
    this.isInputFocused = true
    this.setState({ showDropdown: true })
  }

  // จัดการเมื่อ blur จากช่องค้นหา
  handleSearchBlur = () => {
    var self = this
    // หน่วงเวลาเพื่อให้ click event บน dropdown ทำงานก่อน
    setTimeout(function() {
      self.isInputFocused = false
    }, 300)
  }

  // จัดการเปิดหน้าต่างใหม่
  handleOpenNewWindow = (item) => {
    var self = this
    // สร้าง URL เต็มสำหรับ path ภายใน
    var url = item.path
    if (item.urlType !== 2) {
      // URL ภายใน - ต้องสร้าง path เต็ม
      url = window.location.origin + item.path
    }
    window.open(url, '_blank', 'noopener,noreferrer')
    self.handleSearchItemClick(item)
  }

  // แสดงเมนู dropdown ผลการค้นหา
  renderSearchDropdown = () => {
    var self = this
    var searchResults = this.state.searchResults
    var searchText = this.state.searchText
    var searchHistory = this.state.searchHistory

    // ถ้าไม่มีคำค้นหา แสดงประวัติการค้นหาล่าสุด
    if (!searchText.trim()) {
      if (searchHistory.length === 0) {
        return (
          <Menu>
            <Menu.Item disabled>พิมพ์เพื่อค้นหาเมนู</Menu.Item>
          </Menu>
        )
      }

      return (
        <Menu
          style={{ maxHeight: '300px', overflowY: 'auto', minWidth: '250px' }}
        >
          <Menu.Item
            disabled
            style={{ color: '#999', fontSize: '12px', cursor: 'default' }}
          >
            <Icon type='history' style={{ marginRight: '8px' }} />
            รายการค้นหาล่าสุด
          </Menu.Item>
          <Menu.Divider />
          {searchHistory.map(function(item, index) {
            return (
              <Menu.Item key={'history-' + index}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <a
                    href={
                      item.urlType === 2
                        ? item.path
                        : window.location.origin + item.path
                    }
                    target='_blank'
                    rel='noopener noreferrer'
                    onClick={function(e) {
                      e.preventDefault()
                      self.handleOpenNewWindow(item)
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      flex: 1,
                      overflow: 'hidden',
                    }}
                  >
                    <Icon
                      type='clock-circle'
                      style={{
                        marginRight: '8px',
                        color: '#999',
                        flexShrink: 0,
                      }}
                    />
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: '#999',
                      }}
                    >
                      {item.name}
                    </span>
                  </a>
                  <Tooltip title='ลบรายการค้นหานี้' placement='right'>
                    <Icon
                      type='delete'
                      style={{
                        marginLeft: '8px',
                        color: '#999',
                        cursor: 'pointer',
                        flexShrink: 0,
                      }}
                      onClick={function(e) {
                        self.removeSearchHistoryItem(item.key, e)
                      }}
                    />
                  </Tooltip>
                </div>
              </Menu.Item>
            )
          })}
        </Menu>
      )
    }

    // ถ้ามีคำค้นหาแต่ไม่พบผลลัพธ์
    if (searchResults.length === 0) {
      return (
        <Menu>
          <Menu.Item disabled>ไม่พบผลลัพธ์</Menu.Item>
        </Menu>
      )
    }

    // แสดงผลการค้นหา
    return (
      <Menu
        style={{ maxHeight: '300px', overflowY: 'auto', minWidth: '200px' }}
      >
        {searchResults.map(function(item, index) {
          return (
            <Menu.Item key={'search-' + index}>
              <a
                href={
                  item.urlType === 2
                    ? item.path
                    : window.location.origin + item.path
                }
                target='_blank'
                rel='noopener noreferrer'
                onClick={function(e) {
                  e.preventDefault()
                  self.handleOpenNewWindow(item)
                }}
                style={{ display: 'block', cursor: 'pointer' }}
              >
                <p style={{ margin: '0px', lineHeight: '1em' }}>
                  {self.highlightText(item.name, searchText)}
                </p>
                <p style={{ margin: '0px', fontSize: '12px', color: '#999' }}>
                  {item && item.menu_hierarchy_trans && (
                    <span>{item.menu_hierarchy_trans}</span>
                  )}
                </p>
              </a>
            </Menu.Item>
          )
        })}
      </Menu>
    )
  }

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(
      (key) => this.state.openKeys.indexOf(key) === -1,
    )

    // ถ้าไม่มี key ใหม่ (กำลังปิด submenu) ให้ใช้ openKeys ที่ส่งมา
    if (!latestOpenKey) {
      this.setState({ openKeys })
      return
    }

    if (this.isRootSubmenu(latestOpenKey)) {
      // ถ้าเป็น root submenu - ปิด root submenu อื่นทั้งหมด และเปิดเฉพาะอันใหม่
      this.setState({
        openKeys: [latestOpenKey],
      })
    } else {
      // ถ้าเป็น nested submenu - อนุญาตให้เปิดหลายอันพร้อมกันภายใน root menu เดียวกัน
      this.setState({
        openKeys: [...openKeys],
      })
    }
  }

  handleActiveMenu = (key) => {
    this.setState({
      isActive: key,
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true
  }

  createExternalMenu = (permissions, menu_hierarchy) => {
    if (!permissions || !Array.isArray(permissions)) {
      return null
    }

    const externalPermissions = permissions.filter(
      (permission) =>
        permission.url_type &&
        permission.url_type == 2 &&
        permission.web_use === 'isupply' &&
        permission.can_view === 1,
    )

    const dynamicMenuItems = externalPermissions
      .filter((p) => p.menu_hierarchy === menu_hierarchy)
      .map((p) => (
        <Menu.Item
          key={autoGenKey('slider-sub-menu')}
          matching_name={p.matching_name}
          web_endpoint={this.state.web_endpoint}
          web_use='isupply'
          style={{
            backgroundColor:
              this.state.isActive === p.matching_name && '#ff000070',
          }}
        >
          <CustomMenuItem
            matching_name={p.matching_name}
            permissions={permissions}
          >
            <a href={p.url} target='_blank' rel='noopener noreferrer'>
              <span className='nav-text'>{p.name}</span>
            </a>
          </CustomMenuItem>
        </Menu.Item>
      ))

    return dynamicMenuItems
  }

  render() {
    const { collapsed, language } = this.props
    const { permissions } = this.props.profile

    var self = this

    return (
      <div>
        {/* Menu Search Input */}
        <div
          style={{ padding: '10px 16px', borderBottom: '1px solid #e8e8e8' }}
        >
          <Dropdown
            overlay={this.renderSearchDropdown()}
            visible={this.state.showDropdown}
            onVisibleChange={this.handleDropdownVisibleChange}
            trigger={['click']}
          >
            <Input
              placeholder={
                language === 'en' ? 'Search menu...' : 'ค้นหาเมนู...'
              }
              prefix={
                <Icon type='search' style={{ color: 'rgba(0,0,0,.25)' }} />
              }
              value={this.state.searchText}
              onChange={function(e) {
                self.handleSearchChange(e, permissions, language)
              }}
              onFocus={this.handleSearchFocus}
              onBlur={this.handleSearchBlur}
              allowClear
              style={{ width: '100%' }}
            />
          </Dropdown>
        </div>
        <Menu
          mode='inline'
          theme='light'
          // inlineIndent={0}
          className='ant-side-menu'
          selectable={false}
        >
          {/* Stock วัตถุดิบ */}
          <AutorizeMenu
            isActive={this.state.isActive}
            handleActiveMenu={this.handleActiveMenu}
            permissions={permissions}
            title={
              <span>
                <MenuIcon style={{ fontSize: '21px', color: 'red' }} />
                <span>
                  {' '}
                  <LangContext.Consumer>
                    {(i18n) => i18n.menuHierarchy.stockMaterial}
                  </LangContext.Consumer>
                </span>
              </span>
            }
            subkey={'stockMaterial-sub-menu'}
            handleonOpenChange={this.onOpenChange}
            openKeysMenu={this.state.openKeys}
            menu_hierarchy='stockMaterial'
            createExternalMenu={this.createExternalMenu}
          >
            {/* ยอดเคาะเช้า */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='beginingStock'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              className='slider_bar_effect'
              style={{
                backgroundColor:
                  this.state.isActive === 'beginingStock' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='beginingStock'
                permissions={permissions}
              >
                <Link to='/begining-stock'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.menuHierarchy.enterMorningStock}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>

            {/* ตั้งค่าสต็อกวัตถุดิบ || Realtime Stock */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='settingMaterialStock'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              className='slider_bar_effect'
              style={{
                backgroundColor:
                  this.state.isActive === 'settingMaterialStock' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='settingMaterialStock'
                permissions={permissions}
              >
                <Link to='/setting-material-stock'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.menuHierarchy.realtimeStock}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>

            {/* แดชบอร์ดบริหารวัตถุดิบ */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='StockManagementDashboard'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              style={{
                backgroundColor:
                  this.state.isActive === 'StockManagementDashboard' &&
                  '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='StockManagementDashboard'
                permissions={permissions}
              >
                <Link to='/isupply-stock-management-dashboard'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) =>
                        i18n.menuHierarchy.materialManagementAdministrator
                      }
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>
          </AutorizeMenu>

          {/* ------------------------------------------------------------------------------------- */}

          {/* ส่ง - รับ - ติดตาม */}
          <AutorizeMenu
            isActive={this.state.isActive}
            handleActiveMenu={this.handleActiveMenu}
            permissions={permissions}
            title={
              <span>
                {/* <Icon
                  type='dot-chart'
                  style={{ color: 'red', fontSize: 'larger' }}
                /> */}
                <TruckIcon style={{ fontSize: '21px', color: 'red' }} />
                <span>
                  {' '}
                  <LangContext.Consumer>
                    {(i18n) =>
                      i18n.menuHierarchy.orderReceiveMaterialDeliverTracking
                    }
                  </LangContext.Consumer>
                </span>
              </span>
            }
            subkey={'orderReceiveMaterialDeliverTracking-sub-menu'}
            handleonOpenChange={this.onOpenChange}
            openKeysMenu={this.state.openKeys}
            menu_hierarchy='orderReceiveMaterialDeliverTracking'
            createExternalMenu={this.createExternalMenu}
          >
            {/* การขนส่งวัตถุดิบ */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='deliveryDashboard'
              web_endpoint={this.state.web_endpoint} // fleetlink
              web_use='isupply'
              style={{
                backgroundColor:
                  this.state.isActive === 'deliveryDashboard' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='deliveryDashboard'
                permissions={permissions}
              >
                <Row>
                  <Link
                    to='/isupply-dashboard'
                    style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                  >
                    <Col span={14}>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.d.deliveryDashboard}
                        </LangContext.Consumer>
                      </span>
                    </Col>
                    <Col span={10} align='right'>
                      {/* ปุ่มสั่งวัตถุดิบ */}
                      {checkPermissions(
                        this.props.profile.permissions,
                        'requestMaterial',
                        'can_add',
                      ) && (
                        <Link
                          to='/request-material/multiple-create'
                          style={{ color: 'rgba(0, 0, 0, 0.65)' }}
                        >
                          <Button
                            type='default'
                            size='small'
                            style={{ fontSize: '12px', padding: '0px 3px' }}
                          >
                            <span>
                              <Icon
                                type='plus'
                                style={{ marginRight: '3px', fontSize: '12px' }}
                              />
                            </span>
                            <span className='nav-text'>
                              <LangContext.Consumer>
                                {(i18n) =>
                                  i18n.menuHierarchy.orderReceiveDeliverTracking
                                }
                              </LangContext.Consumer>
                            </span>
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Link>
                </Row>
              </CustomMenuItem>
            </Menu.Item>
          </AutorizeMenu>

          {/* ------------------------------------------------------------------------------------- */}

          {/* คุณภาพวัตถุดิบ */}
          <AutorizeMenu
            isActive={this.state.isActive}
            handleActiveMenu={this.handleActiveMenu}
            permissions={permissions}
            title={
              <span>
                <ShieldCheckIcon style={{ fontSize: '21px', color: 'red' }} />
                <span>
                  {' '}
                  <LangContext.Consumer>
                    {(i18n) => i18n.menuHierarchy.materialQuality}
                  </LangContext.Consumer>
                </span>
              </span>
            }
            subkey={'evaluation-sub-menu'}
            handleonOpenChange={this.onOpenChange}
            openKeysMenu={this.state.openKeys}
            menu_hierarchy='materialQuality'
            createExternalMenu={this.createExternalMenu}
          >
            {/* คุณภาพต้นแหล่ง */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='source-quality-log'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              className='slider_bar_effect'
              style={{
                backgroundColor:
                  this.state.isActive === 'source-quality-log' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='source-quality-log'
                permissions={permissions}
              >
                <Link to=''>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.s.source_quality_evaluation_dashboard}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>

            {/* คุณภาพประจำงวด */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              //key={autoGenKey(`sub-menu`)}
              key='qualityTestingPeriodic_1'
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.menuHierarchy.qualityPeriodic}
                </LangContext.Consumer>
              }
              menu_hierarchy='materialQuality > qualityPeriodic'
            >
              {/* การประเมินคุณภาพสินค้าต้นแหล่ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='sourceQualityEvaluation'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'sourceQualityEvaluation' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='sourceQualityEvaluation'
                  permissions={permissions}
                >
                  <Link to='/source-quality-evaluation'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.source_quality_evaluation}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* การประเมินคุณภาพสินค้า lab */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='labQualityEvaluation'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'labQualityEvaluation' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='labQualityEvaluation'
                  permissions={permissions}
                >
                  <Link to='/lab-quality-evaluation'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.l.lab_quality_evaluation}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* คุณภาพประจำวัน quickTest */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='quickTest'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              style={{
                backgroundColor:
                  this.state.isActive === 'quickTest' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='quickTest'
                permissions={permissions}
              >
                <Link to='/quick-test'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.q.quick_test_evaluation}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>
          </AutorizeMenu>

          {/* ------------------------------------------------------------------------------------- */}

          {/* รายงาน */}
          <AutorizeMenu
            isActive={this.state.isActive}
            handleActiveMenu={this.handleActiveMenu}
            permissions={permissions}
            title={
              <span>
                {/* <Icon
                  type='exception'
                  style={{ color: 'red', fontSize: 'larger' }}
                /> */}
                <FileTextIcon style={{ fontSize: '21px', color: 'red' }} />
                <span>
                  {' '}
                  <LangContext.Consumer>
                    {(i18n) => i18n.r.report}
                  </LangContext.Consumer>
                </span>
              </span>
            }
            subkey={'report-sub-menu'}
            handleonOpenChange={this.onOpenChange}
            openKeysMenu={this.state.openKeys}
            menu_hierarchy='report'
            createExternalMenu={this.createExternalMenu}
          >
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='schedulereport'
              web_endpoint={this.state.web_endpoint}
              className={collapsed ? '' : 'menu-item-wrap'}
              style={{
                backgroundColor:
                  this.state.isActive === 'schedulereport' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='schedulereport'
                permissions={permissions}
              >
                <Link to='/schedulereport'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.s.schedulereport}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>

            {/* ทริป */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'trip_report_menu_1'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.t.trip_report_menu}
                </LangContext.Consumer>
              }
              menu_hierarchy='report > trip'
            >
              {/* การส่งคอนกรีต */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='concreteTrip'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'concreteTrip' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='concreteTrip'
                  permissions={permissions}
                >
                  <Link to='/report/rmcconcretetrip'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.c.concreteTrip}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* การขนส่งวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='deliveryReport'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'deliveryReport' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='deliveryReport'
                  permissions={permissions}
                >
                  <Link to='/isupply-delivery-report'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.d.deliveryReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* การขนส่งวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='weighingHistoryReport'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'weighingHistoryReport' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='weighingHistoryReport'
                  permissions={permissions}
                >
                  <Link to='/isupply-weighing-history-report'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.w.weighingHistoryReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* จัดส่ง พื้น-ผนัง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='floorWallDelivery'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'floorWallDelivery' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='floorWallDelivery'
                  permissions={permissions}
                >
                  <Link to='/precast-report'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.f.floorWallDelivery}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ระยะทางการจัดส่งคอนกรีต */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='distancereport'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'distancereport' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='distancereport'
                  permissions={permissions}
                >
                  <Link to='/report/distancereport'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.d.distancereport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สรุปการวิ่งแยกตามทริป */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='TripsummaryReport'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'TripsummaryReport' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='TripsummaryReport'
                  permissions={permissions}
                >
                  <Link to='/report/tripsummary'>
                    <span className='nav-text'>
                      {' '}
                      <LangContext.Consumer>
                        {(i18n) => i18n.t.TripsummaryReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สรุปการวิ่งประจำวัน */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='DailyReport'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'DailyReport' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='DailyReport'
                  permissions={permissions}
                >
                  <Link to='/report/daily'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.d.DailyReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สรุปจำนวนงานตามสถานที่ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='TripsumbylocationReport'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'TripsumbylocationReport' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='TripsumbylocationReport'
                  permissions={permissions}
                >
                  <Link to='/report/tripsumbylocation'>
                    <span className='nav-text'>
                      {' '}
                      <LangContext.Consumer>
                        {(i18n) => i18n.t.TripsumbylocationReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สรุปการวิ่งแยกตามพาหนะ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='TripsumbyvehReport'
                web_endpoint={this.state.web_endpoint}
                className={collapsed ? '' : 'menu-item-wrap'}
                style={{
                  backgroundColor:
                    this.state.isActive === 'TripsumbyvehReport' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='TripsumbyvehReport'
                  permissions={permissions}
                >
                  <Link to='/report/tripsumbyveh'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.t.TripsumbyvehReport}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* ประวัติ */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'history_menu_1'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.h.history}
                </LangContext.Consumer>
              }
              menu_hierarchy='report > history'
            >
              {/* รายการสั่งวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='requestMaterial'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'requestMaterial' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='requestMaterial'
                  permissions={permissions}
                >
                  <Link to='/request-material'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.r.requestMaterial}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สร้างกองงาน */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplySaleOrder'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplySaleOrder' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplySaleOrder'
                  permissions={permissions}
                >
                  <Link to='/isupply-saleorder'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplySaleOrder}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* รายการสั่งวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='orderHistory'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'orderHistory' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='orderHistory'
                  permissions={permissions}
                >
                  <Link to='/order-history'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.o.orderHistoryMaterial}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ประวัติยอดจองคอนกรีต (ClickUp 86d47txe6)
                  ⚠️ ยังไม่มีแถว saleOrderHistory ใน m_permission → CustomMenuItem fallback
                  แสดง children ให้ทุกคน แต่ตัวหน้า gate ด้วยสิทธิ์ orderHistory
                  (ดู sale-order-history/components/Index.js: PERMISSION_MATCHING_NAME) */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='orderHistory'
                /* ⚠️ matching_name ต้องเป็น 'orderHistory' เพราะ AutorizeMenu ใช้กรองสิทธิ์
                   และยังไม่มีแถว saleOrderHistory ใน m_permission (ใส่ชื่อจริง = เมนูหายไปเลย)
                   แต่ไฮไลต์ต้องเป็นของตัวเอง → แยกด้วย active_key (user แจ้ง 2026-09-14)
                   สร้างแถวสิทธิ์จริงเมื่อไหร่ ทั้งสองค่าจะเท่ากัน ถอด active_key ทิ้งได้ */
                active_key='saleOrderHistory'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'saleOrderHistory' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='saleOrderHistory'
                  permissions={permissions}
                >
                  <Link to='/sale-order-history'>
                    <span className='nav-text'>ประวัติยอดจองคอนกรีต</span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* Stock balance รายการปรับวัตถุดิบคงเหลือ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyStockBalance'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyStockBalance' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyStockBalance'
                  permissions={permissions}
                >
                  <Link to='/stock-balance'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.stockBalance}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>
          </AutorizeMenu>

          {/* ------------------------------------------------------------------------------------- */}

          {/* Setting */}
          <AutorizeMenu
            isActive={this.state.isActive}
            handleActiveMenu={this.handleActiveMenu}
            permissions={permissions}
            title={
              <span>
                {/* <Icon
                  type='dot-chart'
                  style={{ color: 'red', fontSize: 'larger' }}
                /> */}
                <SettingIcon style={{ fontSize: '21px', color: 'red' }} />
                <span>
                  {' '}
                  <LangContext.Consumer>
                    {(i18n) => i18n.menuHierarchy.setting}
                  </LangContext.Consumer>
                </span>
              </span>
            }
            subkey={'setting-sub-menu'}
            handleonOpenChange={this.onOpenChange}
            openKeysMenu={this.state.openKeys}
            menu_hierarchy='setting'
            createExternalMenu={this.createExternalMenu}
          >
            {/* ประสิทธิภาพการขนส่งวัตถุดิบ */}
            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              className={collapsed ? '' : 'menu-item-wrap'}
              matching_name='transportationPerformanceDashboard'
              web_endpoint={this.state.web_endpoint}
              web_use='isupply'
              style={{
                backgroundColor:
                  this.state.isActive ===
                    'transportationPerformanceDashboard' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='transportationPerformanceDashboard'
                permissions={permissions}
              >
                <Link to='/isupply-overview-performance-dashboard'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.t.transportationPerformanceDashboard}
                    </LangContext.Consumer>
                  </span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>

            {/* sub แดชบอร์ด */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'dashboard'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.d.dashboard}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > dashboard'
            >
              {/* ความปลอดภัย */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='SafetyDashboard'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'SafetyDashboard' && '#ff000070',
                  color: this.state.isActive === 'SafetyDashboard' && 'white',
                }}
              >
                <CustomMenuItem
                  matching_name='SafetyDashboard'
                  permissions={permissions}
                >
                  <Link to='/safety_dashboard'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.safetyDashboard}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ขนส่งทางเรือ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='shippingDashboard'
                web_endpoint={this.state.web_endpoint} // fleetlink
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'shippingDashboard' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='shippingDashboard'
                  permissions={permissions}
                >
                  <Link to='/shipping-dashboard'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.shippingDashboard}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* การติดตามวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='theStatusOfVehiclesThatReceiveDailyJobs'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                className='slider_bar_effect'
                style={{
                  backgroundColor:
                    this.state.isActive ===
                      'theStatusOfVehiclesThatReceiveDailyJobs' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='theStatusOfVehiclesThatReceiveDailyJobs'
                  permissions={permissions}
                >
                  <Link to='/isupply-status-vehicles-receive-daily-jobs'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) =>
                          i18n.t.theStatusOfVehiclesThatReceiveDailyJobs
                        }
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* command center dashboard */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='commandCenterDashboard'
                web_endpoint={this.state.web_endpoint} // fleetlink
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'commandCenterDashboard' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='commandCenterDashboard'
                  permissions={permissions}
                >
                  <Link to='/command-center-dashboard' target='_blank'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.c.commandCenterDashboard}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* sub คุณภาพวัตถุดิบ */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'quality_evaluation'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.menuHierarchy.materialQuality}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > materialQuality'
            >
              {/* สรุปผลคุณภาพวัตถุดิบ (ต้นแหล่ง) */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='sourceQualityEvaluationDashboard'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                className='slider_bar_effect'
                style={{
                  backgroundColor:
                    this.state.isActive ===
                      'sourceQualityEvaluationDashboard' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='sourceQualityEvaluationDashboard'
                  permissions={permissions}
                >
                  {/* <Link to='/source-quality-evaluation-dashboard'>
                  <span className='nav-text'>
                    <LangContext.Consumer>
                      {(i18n) => i18n.s.source_quality_evaluation_dashboard}
                    </LangContext.Consumer>
                  </span>
                </Link> */}
                </CustomMenuItem>
              </Menu.Item>

              {/* survey sourcing */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='surveySourcing'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                className='slider_bar_effect'
                style={{
                  backgroundColor:
                    this.state.isActive === 'surveySourcing' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='surveySourcing'
                  permissions={permissions}
                >
                  <Link to='/survey-sourcing'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.surveySourcing}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* sub ระบบจัดการกองรถ */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'fleetManagement'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.menuHierarchy.fleetManagement}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > fleetManagement'
            >
              {/* แผนงานกองรถ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyBookingOrder'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyBookingOrder' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyBookingOrder'
                  permissions={permissions}
                >
                  <Link to='/booking-order'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyBookingOrder}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ปฏิทินงานกองรถ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyBookingDashboard'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyBookingDashboard' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyBookingDashboard'
                  permissions={permissions}
                >
                  <Link to='/isupply-booking-scheduler/month'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyBookingDashboard}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* ระบบติดตาม */}
            {/* <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              //key={autoGenKey(`sub-menu`)}
              key='moitoring'
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.m.monitoring}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > location'
            > */}
            {/* ติดตามยานพาหนะ */}
            {/* <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='tracking'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'tracking' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='tracking'
                  permissions={permissions}
                >
                  <Link to='/tracking'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.t.tracking}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item> */}

            {/* เส้นทางเดินทางย้อนหลัง */}
            {/* <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='replay'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'replay' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='replay'
                  permissions={permissions}
                >
                  <Link to='/replay'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.r.replay}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>*/}
            {/* </Menu.SubMenu>  */}

            {/* บริหารวัตถุดิบ */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              //key={autoGenKey(`sub-menu`)}
              key='materialQuotaManagement'
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.m.materialQuotaManagement}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > materialQuotaManagement'
            >
              {/* จัดการโควต้าวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='masterDataMatrialQuota'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'masterDataMatrialQuota' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='masterDataMatrialQuota'
                  permissions={permissions}
                >
                  <Link to='/manage-material-quota'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.m.manageMaterialQuota}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* โควตาวัตถุดิบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='masterDataMatrialQuotaAssign'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'masterDataMatrialQuotaAssign' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='masterDataMatrialQuotaAssign'
                  permissions={permissions}
                >
                  <Link to='/material-quota'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.m.materialQuota}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* โควตาผู้รับเหมา */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='contractorQuota'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'contractorQuota' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='contractorQuota'
                  permissions={permissions}
                >
                  <Link to='/contractor-quota'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.c.contractorQuota}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* การจัดการ */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              //key={autoGenKey(`sub-menu`)}
              key='management'
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.m.management_menu}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > management'
            >
              {/* ผู้ใช้งาน */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='user'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'user' && '#ff000070',
                }}
              >
                <CustomMenuItem matching_name='user' permissions={permissions}>
                  <Link to='/user'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.u.user}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* กลุ่มผู้ใช้งาน */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='userGroup'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'userGroup' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='userGroup'
                  permissions={permissions}
                >
                  <Link to='/usergroup'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.u.userGroup}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* การมองเห็นข้อมูล */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='dataVisibility'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'dataVisibility' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='dataVisibility'
                  permissions={permissions}
                >
                  <Link to='/datavisibility'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.d.dataVisibility}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* generate token */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='generateToken'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'generateToken' && '#1890FF70',
                }}
              >
                <CustomMenuItem
                  matching_name='generateToken'
                  permissions={permissions}
                >
                  <Link to='/generateusertoken'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.g.generateTokenAccount}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* แชร์พาหนะ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='vehicleSharing'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'vehicleSharing' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='vehicleSharing'
                  permissions={permissions}
                >
                  <Link to='/vehicle_sharing'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.v.vehicleSharing}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* เเชร์สถานที่ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='shareLocation'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'shareLocation' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='shareLocation'
                  permissions={permissions}
                >
                  <Link to='/sharelocation'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.shareLocation}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ผู้เช่าพาหนะ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='partnerCar'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'partnerCar' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='partnerCar'
                  permissions={permissions}
                >
                  <Link to='/partner'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.p.partnerCar}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* แผนการจัดส่ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='routemaster'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'routemaster' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='routemaster'
                  permissions={permissions}
                >
                  <Link to='/routemaster'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.r.routemaster}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* จัดรถของ ผรม. isupply */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyManageVehicle'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyManageVehicle' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyManageVehicle'
                  permissions={permissions}
                >
                  <Link to='/isupply-manage-vehicle'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyManageVehicle}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* isupply multidrop */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyMultidrop'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyMultidrop' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyMultidrop'
                  permissions={permissions}
                >
                  <Link to='/multidrop'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyMultidrop}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            {/* ข้อมูลหลัก */}
            <Menu.SubMenu
              popupClassName='popup-menu-custom scroll-style'
              key={'masterdata'}
              permissions={permissions}
              title={
                <LangContext.Consumer>
                  {(i18n) => i18n.m.masterData}
                </LangContext.Consumer>
              }
              menu_hierarchy='setting > masterdata'
            >
              {/* สถานที่่ */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                //key={autoGenKey(`sub-menu`)}
                key='location_1'
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.l.location}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > location'
              >
                {/* สถานที่่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='location'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'location' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='location'
                    permissions={permissions}
                  >
                    <Link to='/location'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.l.Location}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* พื้นที่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='zone'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'zone' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='zone'
                    permissions={permissions}
                  >
                    <Link to='/zone'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.z.zone}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* พาหนะห้ามเข้าพื้นที่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='vehicleBlacklist'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'vehicleBlacklist' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='vehicleBlacklist'
                    permissions={permissions}
                  >
                    <Link to='/isupply-vehicle-blacklist'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.v.vehicleBlacklist}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* พนักงานห้ามเข้าพื้นที่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='driverBlacklist'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'driverBlacklist' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='driverBlacklist'
                    permissions={permissions}
                  >
                    <Link to='/isupply-driver-blacklist'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.d.driverBlacklist}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* สถานที่ใกล้เคียง */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='nearByLocation'
                  web_endpoint={this.state.web_endpoint}
                  style={{
                    backgroundColor:
                      this.state.isActive === 'nearByLocation' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='nearByLocation'
                    permissions={permissions}
                  >
                    <Link to='/nearbylocation'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.n.nearByLocation}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* กลุ่มสถานที่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='locationGroup'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'locationGroup' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='locationGroup'
                    permissions={permissions}
                  >
                    <Link to='/locationgroup'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.l.locationGroup}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* กลุ่มหน่วยงาน */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='siteGroup'
                  web_endpoint={this.state.web_endpoint}
                  style={{
                    backgroundColor:
                      this.state.isActive === 'siteGroup' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='siteGroup'
                    permissions={permissions}
                  >
                    <Link to='/sitegroup'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.s.siteGroup}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* พาหนะ */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                key={'vehicle_1'}
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.v.vehicle}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > vehicle'
              >
                {/* ประเภท พาหนะ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='vehicle_type'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'vehicle_type' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='vehicle_type'
                    permissions={permissions}
                  >
                    <Link to='/vehicle-type'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.v.vehicle_type}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
                {/* พาหนะ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='vehicle'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'vehicle' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='vehicle'
                    permissions={permissions}
                  >
                    <Link to='/vehicle'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.v.vehicle}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* กลุ่มพาหนะ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='vehicleGroup'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  style={{
                    backgroundColor:
                      this.state.isActive === 'vehicleGroup' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='vehicleGroup'
                    permissions={permissions}
                  >
                    <Link to='/vehiclegroup'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.v.vehicleGroup}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* พนักงานขับขี่ */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                key={'chauffeur_1'}
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.c.chauffeur}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > driver'
              >
                {/* พนักงานขับขี่ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='chauffeur'
                  web_endpoint={this.state.web_endpoint}
                  web_use=''
                  className={collapsed ? '' : 'menu-item-wrap'}
                  style={{
                    backgroundColor:
                      this.state.isActive === 'chauffeur' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='chauffeur'
                    permissions={permissions}
                  >
                    <Link to='/deviceuser'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.c.chauffeur}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* วัตถุดิบ */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                key={'material_1'}
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.m.material}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > material'
              >
                {/* วัตถุดิบ */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='masterDataMatrial'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'masterDataMatrial' &&
                      '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='masterDataMatrial'
                    permissions={permissions}
                  >
                    <Link to='/material'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.m.masterDataMatrial}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* วัตถุดิบ เทียบ*/}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='comparativeRawMaterials'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'comparativeRawMaterials' &&
                      '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='comparativeRawMaterials'
                    permissions={permissions}
                  >
                    <Link to='/sub-material'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.c.comparativeRawMaterials}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* รถเช่า */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                key={'carRental'}
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.c.carRental}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > carRental'
              >
                {/* ตั้งค่า ใบเสนอราคา */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='rentalPrice'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'rentalPrice' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='rentalPrice'
                    permissions={permissions}
                  >
                    <Link to='/rental-price'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.r.rentalPrice}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* ตั้งค่า ค่าใช้จ่ายส่วนเกิน */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='excessExpenses'
                  web_endpoint={this.state.web_endpoint}
                  web_use='isupply'
                  style={{
                    backgroundColor:
                      this.state.isActive === 'excessExpenses' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='excessExpenses'
                    permissions={permissions}
                  >
                    <Link to='/excess-expenses'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.e.excessExpenses}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* วันหยุดผู้ขนส่ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyHolidays'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyHolidays' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyHolidays'
                  permissions={permissions}
                >
                  <Link to='/isupply-holidays'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyHolidays}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สัญญาขนส่ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='plantMiningContract'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'plantMiningContract' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='plantMiningContract'
                  permissions={permissions}
                >
                  <Link to='/delivery-contract'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.p.plantMiningContract}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* สัญญาการจัดส่ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='shipmentContract'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'shipmentContract' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='shipmentContract'
                  permissions={permissions}
                >
                  <Link to='/shipping-contract'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.shippingContract}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* บัตรแข็ง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='truckPickupCard'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'truckPickupCard' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='truckPickupCard'
                  permissions={permissions}
                >
                  <Link to='/truck-pickup-card'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.t.truckPickupCard}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ภาพตัวอย่าง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='sampleImages'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'sampleImages' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='sampleImages'
                  permissions={permissions}
                >
                  <Link to='/sample-image'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.sampleImages}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ลายเซ็น */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='signatureImage'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'signatureImage' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='signatureImage'
                  permissions={permissions}
                >
                  <Link to='/signature-image'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.s.signatureImage}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* กุญเเจเชื่อมระบบ */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplySystemKey'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplySystemKey' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplySystemKey'
                  permissions={permissions}
                >
                  <Link to='/interface-key-cdas'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplySystemKey}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* Precast */}
              <Menu.SubMenu
                popupClassName='popup-menu-custom scroll-style'
                key={'pre_cast_1'}
                permissions={permissions}
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.vehicleType.pre_cast}
                  </LangContext.Consumer>
                }
                menu_hierarchy='setting > masterdata > precast'
              >
                {/* ข้อมูล เเผนการวิ่งรถ (ผนัง) */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='informationAboutTheCarRunWall'
                  web_endpoint={this.state.web_endpoint}
                  className={collapsed ? '' : 'menu-item-wrap'}
                  style={{
                    backgroundColor:
                      this.state.isActive === 'informationAboutTheCarRunWall' &&
                      '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='informationAboutTheCarRunWall'
                    permissions={permissions}
                  >
                    <Link to='/cpac-precast-transportation-information-wall'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.i.informationAboutTheCarRunWall}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>

                {/* ข้อมูล เเผนการวิ่งรถ (พื้น) */}
                <Menu.Item
                  key={autoGenKey('slider-sub-menu')}
                  matching_name='informationAboutTheCarRunFloor'
                  web_endpoint={this.state.web_endpoint}
                  className={collapsed ? '' : 'menu-item-wrap'}
                  style={{
                    backgroundColor:
                      this.state.isActive ===
                        'informationAboutTheCarRunFloor' && '#ff000070',
                  }}
                >
                  <CustomMenuItem
                    matching_name='informationAboutTheCarRunFloor'
                    permissions={permissions}
                  >
                    <Link to='/cpac-precast-transportation-information-floor'>
                      <span className='nav-text'>
                        <LangContext.Consumer>
                          {(i18n) => i18n.i.informationAboutTheCarRunFloor}
                        </LangContext.Consumer>
                      </span>
                    </Link>
                  </CustomMenuItem>
                </Menu.Item>
              </Menu.SubMenu>

              {/* สินค้า */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='product'
                web_endpoint={this.state.web_endpoint}
                style={{
                  backgroundColor:
                    this.state.isActive === 'product' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='product'
                  permissions={permissions}
                >
                  <Link to='/product'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.p.product}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* หน่วยนับ (UOM) */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='uom'
                style={{
                  backgroundColor: this.state.isActive === 'uom' && '#ff000070',
                }}
              >
                <CustomMenuItem matching_name='uom' permissions={permissions}>
                  <Link to='/uom'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.u.uom}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* ลูกค้า */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='customer'
                web_endpoint={this.state.web_endpoint}
                style={{
                  backgroundColor:
                    this.state.isActive === 'customer' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='customer'
                  permissions={permissions}
                >
                  <Link to='/customer'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.c.customer}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* Permission */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='permission'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'permission' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='permission'
                  permissions={permissions}
                >
                  <Link to='/permission'>
                    <span className='nav-text'>Permission</span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='maintenance'
                web_endpoint={this.state.web_endpoint}
                style={{
                  backgroundColor:
                    this.state.isActive === 'maintenance' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='maintenance'
                  permissions={permissions}
                >
                  <Link to='/maintenance'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.m.maintenance}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='reFuelTitle'
                web_endpoint={this.state.web_endpoint}
                style={{
                  backgroundColor:
                    this.state.isActive === 'reFuelTitle' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='reFuelTitle'
                  permissions={permissions}
                >
                  <Link to='/refuel'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.r.reFuelTitle}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* เชื้อเพลิง */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='company'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'company' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='company'
                  permissions={permissions}
                >
                  <Link to='/company'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.c.company}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* บริษัท */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='sendemail'
                web_endpoint={this.state.web_endpoint}
                style={{
                  backgroundColor:
                    this.state.isActive === 'sendemail' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='sendemail'
                  permissions={permissions}
                >
                  <Link to='/verifyemail'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.a.accountVerification}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* services */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='isupplyServiceActiveLog'
                web_endpoint={this.state.web_endpoint}
                web_use='isupply'
                style={{
                  backgroundColor:
                    this.state.isActive === 'isupplyServiceActiveLog' &&
                    '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='isupplyServiceActiveLog'
                  permissions={permissions}
                >
                  <Link to='/services'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.i.isupplyServiceActiveLog}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>

              {/* Dynamic Sidebar */}
              <Menu.Item
                key={autoGenKey('slider-sub-menu')}
                matching_name='dynamicSidebar'
                web_endpoint={this.state.web_endpoint}
                web_use=''
                style={{
                  backgroundColor:
                    this.state.isActive === 'dynamicSidebar' && '#ff000070',
                }}
              >
                <CustomMenuItem
                  matching_name='dynamicSidebar'
                  permissions={permissions}
                >
                  <Link to='/dynamicSidebar'>
                    <span className='nav-text'>
                      <LangContext.Consumer>
                        {(i18n) => i18n.d.dynamicSidebar}
                      </LangContext.Consumer>
                    </span>
                  </Link>
                </CustomMenuItem>
              </Menu.Item>
            </Menu.SubMenu>

            <Menu.Item
              key={autoGenKey('slider-sub-menu')}
              matching_name='isupplyManageQueue'
              web_endpoint={this.state.web_endpoint}
              style={{
                backgroundColor:
                  this.state.isActive === 'isupplyManageQueue' && '#ff000070',
              }}
            >
              <CustomMenuItem
                matching_name='isupplyManageQueue'
                permissions={permissions}
              >
                <Link to='/isupply-manage-queue'>
                  <span className='nav-text'>Isupply Manage Queue</span>
                </Link>
              </CustomMenuItem>
            </Menu.Item>
          </AutorizeMenu>

          {/* ------------------------------------------------------------------------------------- */}
        </Menu>
      </div>
    )
  }
}

// export default SliderBar;
const mapStateToProps = ({ auth: { profile }, ui: { language } }) => ({
  profile,
  language,
})

export default connect(mapStateToProps, null)(SliderBarNewNode)
